import { render, staticRenderFns } from "./ShippingTable.vue?vue&type=template&id=3de5c53f"
import script from "./ShippingTable.vue?vue&type=script&lang=js"
export * from "./ShippingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports